// extracted by mini-css-extract-plugin
export default {"root":"OverLengthColumn_root__L5nPD","name":"OverLengthColumn_name__NHwqN"};